var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation-UX-(New)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation_New-Update-(Desktop)",
    transform: "translate(-18.000000, -343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-5",
    transform: "translate(0.000000, 282.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(18.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Trophy_1149724",
    transform: "translate(2.000000, 2.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.46,1.015 L15.995,1.015 L15.995,0.35 C15.995,0.14 15.855,0 15.645,0 L4.165,0 C3.955,0 3.815,0.14 3.815,0.35 L3.815,1.015 L0.35,1.015 C0.14,1.015 0,1.155 0,1.365 L0,5.635 C0,8.085 1.89,10.115 4.27,10.325 C4.935,11.795 6.265,12.915 7.91,13.3 L7.91,16.625 L4.76,16.625 C4.55,16.625 4.41,16.765 4.41,16.975 L4.41,20.65 C4.41,20.86 4.55,21 4.76,21 L15.015,21 C15.225,21 15.365,20.86 15.365,20.65 L15.365,16.975 C15.365,16.765 15.225,16.625 15.015,16.625 L11.865,16.625 L11.865,13.3 C13.475,12.95 14.84,11.83 15.505,10.325 C17.92,10.115 19.775,8.085 19.775,5.635 L19.775,1.365 C19.81,1.19 19.67,1.015 19.46,1.015 Z M0.7,5.635 L0.7,1.715 L3.815,1.715 L3.815,8.155 C3.815,8.645 3.885,9.1 4.025,9.555 C2.135,9.24 0.7,7.595 0.7,5.635 Z M14.665,20.3 L5.145,20.3 L5.145,17.325 L14.7,17.325 L14.7,20.3 L14.665,20.3 Z M11.2,16.625 L8.61,16.625 L8.61,13.405 C8.75,13.405 8.89,13.44 9.065,13.44 L10.745,13.44 C10.885,13.44 11.06,13.44 11.2,13.405 L11.2,16.625 L11.2,16.625 Z M10.745,12.705 L9.065,12.705 C6.545,12.705 4.515,10.675 4.515,8.155 L4.515,0.7 L15.295,0.7 L15.295,8.155 C15.295,10.675 13.265,12.705 10.745,12.705 Z M19.11,5.635 C19.11,7.595 17.675,9.24 15.785,9.59 C15.925,9.135 15.995,8.68 15.995,8.19 L15.995,1.715 L19.11,1.715 L19.11,5.635 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/Cup.7374c576ddbf32844e7b1b33f3b2f17f.svg";
export { ForwardRef as ReactComponent };